import { get } from 'lodash';

export const whoisByDomainSelector = state => get( state, 'whois.byDomain', {} );
export const whoisIsLoadingSelector = state => get( state, 'whois.isLoading', false );
